import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMetaTags, getPageSeo, getStructuredData } from '../seo';

export default function Seo() {
	const { pathname } = useLocation();
	useEffect(() => {
		const meta = getPageSeo(pathname);
		document.title = meta.title;
		// Remove optional image metadata from the previous route as well.
		document.head.querySelectorAll('[data-seo]').forEach((node) => node.remove());
		getMetaTags(meta).forEach(([attribute, key, content]) => {
			let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
			if (!tag) {
				tag = document.createElement('meta');
				tag.setAttribute(attribute, key);
				document.head.appendChild(tag);
			}
			tag.content = content;
			tag.setAttribute('data-seo', '');
		});
		const canonical = document.createElement('link');
		canonical.rel = 'canonical';
		canonical.href = meta.url;
		canonical.setAttribute('data-seo', '');
		document.head.appendChild(canonical);
		const schema = document.createElement('script');
		schema.type = 'application/ld+json';
		schema.textContent = JSON.stringify(getStructuredData(meta));
		schema.setAttribute('data-seo', '');
		document.head.appendChild(schema);
	}, [pathname]);
	return null;
}
